import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from "../../shared/shared.module";
import {CarTemplateRoutingModule} from "./car-template-routing.module";
import {CarTemplateEditComponent} from "./edit/car-template-edit.component";
import {CarTemplateListComponent} from "./list/car-template-list.component";
import {CarTemplateListCardComponent} from "./list/card/car-template-list-card.component";
import {CarTemplateModerateComponent} from "./moderate/car-template-moderate.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CarTemplateRoutingModule,
        TranslateModule,
        SharedModule],
    declarations: [
        CarTemplateEditComponent,
        CarTemplateListComponent,
        CarTemplateListCardComponent,
        CarTemplateModerateComponent

    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CarTemplateModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/car-template.module.ts